module.exports = __webpack_public_path__ + "static/media/Medcare Medical Center, Rashidiya.72501a4a.jpg";